import React, { useEffect, useState, useContext } from "react";
import { useNavigate, useParams } from "react-router";
import {
  Table,
  Form,
  Accordion,
  Button,
  FloatingLabel,
  Alert,
} from "react-bootstrap";

import ContextComponent from "../../../AppContext";
import Utils from "../../../Utils";

const EditTemplate = () => {
  const navigate = useNavigate();
  const { templateid } = useParams();
  // console.log("templateid : " + templateid);
  let { setAlert } = useContext(ContextComponent);
  let [canRender, setCanRender] = useState(false);

  let [badgeIds, setBadgeIds] = useState([]);

  let [templateInfo, setTemplateInfo] = useState({
    templateName: "",
    // Newly added to template info
    // ** ----------- ** //
    logoBGColor: "",
    jointLogoBGColor: "",
    jointLogoImage: "",
    includeAddress: "",
    // ** ----------- ** //
    backgroundImage: "",
    logoImage: "",
    profilePicture: "",
    brand: "",
    linkedBadges: [],
  });

  let [logoBGColor, setLogoBGColor] = useState("");
  let [jointLogoBGColor, setJointLogoBGColor] = useState("");

  // let [imgDataArray, setImgDataArray] = useState(["", "", ""]);

  const updateSelectedBadgeInfo = (e) => { };

  const onChangeImage = async (e) => {
    let file = e.currentTarget.files[0];
    let targetImage = e.currentTarget.attributes["imgname"].value;

    document
      .querySelector(".indi-add-img-wrapper-" + targetImage)
      .classList.add("d-none");
    let imgPreviewEle = document.querySelector(
      ".indi-add-img-wrapper-preview-" + targetImage,
    );
    imgPreviewEle.classList.remove("d-none");
    await Utils.fileToDataUri(file).then((dataUri) => {
      imgPreviewEle.src = dataUri;
      let imgObj = {};
      imgObj[targetImage] = dataUri;
      let updatedTemplateInfo = { ...templateInfo, ...imgObj };
      setTemplateInfo(updatedTemplateInfo);
    });
  };

  let [showAlert, setShowAlert] = useState(false);
  let [formValidateErrorMessage, setFormValidateErrorMessage] = useState("");

  const templateNameHandler = (e) => {
    let updatedTemplateInfo = {
      ...templateInfo,
      templateName: e.currentTarget.value,
    };
    setTemplateInfo(updatedTemplateInfo);
  };

  // Newly added Event Handlers
  // ** ----------- ** //
  const templateLogoBGColorHandler = (e) => {
    let val = e.currentTarget.value;

    let updatedTemplateInfo = {
      ...templateInfo,
      logoBGColor: val,
    };
    setTemplateInfo(updatedTemplateInfo);
    setLogoBGColor(val);
    let logoEle1 = document.getElementById("logoColor1");
    logoEle1.value = val;
  };

  const templateLogoBGInputColorHandler = (e) => {
    let val = e.currentTarget.value;

    let updatedTemplateInfo = {
      ...templateInfo,
      logoBGColor: val,
    };
    setTemplateInfo(updatedTemplateInfo);
    setLogoBGColor(val);
    let logoEle = document.getElementById("logoColor");
    logoEle.value = val;
  };

  const templateJointLogoBGColorHandler = (e) => {
    let val = e.currentTarget.value;

    let updatedTemplateInfo = {
      ...templateInfo,
      jointLogoBGColor: val,
    };
    setTemplateInfo(updatedTemplateInfo);
    setJointLogoBGColor(val);
    let jointLogoEle1 = document.getElementById("jointLogoColor1");
    jointLogoEle1.value = val;
  };

  const templateJointLogoBGInputColorHandler = (e) => {
    let val = e.currentTarget.value;

    let updatedTemplateInfo = {
      ...templateInfo,
      jointLogoBGColor: val,
    };
    setTemplateInfo(updatedTemplateInfo);
    setJointLogoBGColor(val);
    let jointLogoEle = document.getElementById("jointLogoColor");
    jointLogoEle.value = val;
  };

  const templateIncludeAddressHandler = (e) => {
    let updatedTemplateInfo = {
      ...templateInfo,
      includeAddress: e.currentTarget.checked,
    };
    setTemplateInfo(updatedTemplateInfo);
  };
  // ** ----------- ** //
  function customEncode(badge) {
    // Simple custom encoding implementation
    // const badgeUID = badge.badgeUID;
    // return btoa(badgeUID).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
    return badge.id;
  }

  const onSaveTemplate = (e) => {
    let linkedBadges = [];
    let existingLinkedBadges = {};

    templateInfo.linkedBadges.forEach((badge) => {
      existingLinkedBadges[badge.badgeUID] = {
        id: badge.id,
        badgeId: badge.badgeId,
      };
    });

    badges.map((badge, index) => {
      const encodedBadgeUID = customEncode(badge);
      let selectItem = document.querySelector(
        ".indi-template-badge-select-" + encodedBadgeUID + " input",
      );
      if (selectItem?.checked) {
        let isConstant = document.querySelector(
          ".indi-template-badge-constant-" + encodedBadgeUID + " input",
        ).checked;
        let isDefault = document.querySelector(
          ".indi-template-badge-isdefault-" + encodedBadgeUID + " input",
        ).checked;
        let isMultiple = document.querySelector(
          ".indi-template-badge-multiple-" + encodedBadgeUID + " input",
        ).checked;
        let defaultValue =
          document.querySelector(
            ".indi-template-badge-defaultvalue-" + encodedBadgeUID,
          ).value || "";

        let prefixObj = existingLinkedBadges[badge.badgeUID]
          ? { ...existingLinkedBadges[badge.badgeUID] }
          : {};

        let tempBadge = {
          ...prefixObj,
          badgeName: badge.name,
          badgeType: badge.type,
          badgeUID: badge.name.toLowerCase(),
          constant: isConstant,
          //darkIconImage: badge.darkIconImage,
          default: isDefault,
          defaultValue: defaultValue,
          //iconImage: badge.iconImage,
          multiple: isMultiple,
          prefixurl: badge.prefixurl,
        };

        linkedBadges.push(tempBadge);
      }
    });

    let updatedTemplateInfo = { ...templateInfo, linkedBadges: linkedBadges };

    setTemplateInfo(updatedTemplateInfo);

    if (validateForm(updatedTemplateInfo)) {
      console.log(updatedTemplateInfo);
      submitTemplateForm(updatedTemplateInfo);
    }
    return false;
  };

  const validateForm = (formData) => {
    let errMsg = [];
    if (formData.templateName.trim().length === 0) {
      errMsg.push("Template name is required");
    }
    if (formData.backgroundImage.trim().length === 0) {
      errMsg.push("Template background image is required");
    }
    if (formData.logoImage.trim().length === 0) {
      errMsg.push("Template logo image is required");
    }
    if (formData.linkedBadges.length === 0) {
      errMsg.push(
        "Atleast one badge should assosiate with the current template",
      );
    }
    if (errMsg.length) {
      setShowAlert(true);
      setFormValidateErrorMessage(errMsg.join(", "));
      return false;
    } else {
      setShowAlert(false);
      setFormValidateErrorMessage("");
      return true;
    }
  };

  const submitTemplateForm = (info) => {
    const success = (res) => {
      navigate(Utils.APP_URLS.TEMPLATES_PAGE);
      setAlert({
        show: true,
        message: "Template modified successfully",
      });
    };
    const fail = (err) => {
      console.log(err);
    };

    try {
      Utils.editTemplate(templateid, info).then(success, fail);
    } catch (e) {
      console.log(e);
    }
  };

  const navigateToTemplatesListPage = (e) => {
    navigate(Utils.APP_URLS.TEMPLATES_PAGE);
  };

  let [hasBrands, setHasBrands] = useState(false);
  let [hasBadges, setHasBadges] = useState(false);
  let [hasTemplateInfo, setHasTemplateInfo] = useState(false);

  let [brands, setBrands] = useState([]);
  let [badges, setBadges] = useState([]);
  let [badgesIds, setBadgesIds] = useState([]);
  let [updatedBadges, setUpdatedBadges] = useState([]);

  // let [selectedBrandValue, setSelectedBrandValue] = useState("");

  const brandsFetchSuccess = (res) => {
    // console.log(res);
    setBrands(res.data);
    // setSelectedBrandValue(res.data[0].name);
    setHasBrands(true);
  };
  const brandsFetchFail = (err) => {
    err?.message?.length && console.log(err);
  };

  useEffect(() => {
    Utils.getBrands().then(brandsFetchSuccess, brandsFetchFail);
  }, []);

  const badgesFetchSuccess = (res) => {
    let tempBadgeIds = [];
    res.data.forEach((badge) => {
      tempBadgeIds.push(badge.id);
    });
    setBadgeIds(tempBadgeIds);

    setBadges(res.data);
    setHasBadges(true);
  };
  const badgesFetchFail = (err) => {
    err?.message?.length && console.log(err);
  };

  useEffect(() => {
    Utils.getBadges().then(badgesFetchSuccess, badgesFetchFail);
  }, []);

  useEffect(() => {
    if (hasBrands && hasBadges && hasTemplateInfo) {
      // console.log(badges);
      // console.log(templateInfo);
      let tempBadges = [...badges];
      tempBadges.forEach((tempBadge) => {
        let updatedBadge = templateInfo.linkedBadges.filter((lb) => {
          let isEqual = lb.badgeName === tempBadge.name;
          if (isEqual) {
            tempBadge.id = lb.id;
          }
          return isEqual;
        });

        if (updatedBadge?.length) {
          updatedBadge = updatedBadge[0];
          tempBadge.templateBadgeId = updatedBadge.id;
          tempBadge.constant = updatedBadge?.constant ?? "";
          tempBadge.multiple = updatedBadge?.multiple ?? false;
          tempBadge.prefixurl = updatedBadge?.prefixurl ?? "";
          tempBadge.default = updatedBadge?.default ?? false;
          tempBadge.defaultValue = updatedBadge?.defaultValue ?? "";
          tempBadge.multiple = updatedBadge?.multiple ?? false;
        }
      });
      // console.log(tempBadges);
      setBadges(tempBadges);
      setCanRender(true);
    }
  }, [hasBrands, hasBadges, hasTemplateInfo]);

  const templateFetchSuccess = (res) => {
    // console.log(res.data);
    setLogoBGColor(res.data.logoBGColor);
    setJointLogoBGColor(res.data.jointLogoBGColor);
    setTemplateInfo(res.data);
    setHasTemplateInfo(true);
  };
  const templateFetchFail = (err) => {
    err?.message?.length && console.log(err);
  };

  useEffect(() => {
    Utils.getTemplateDetails(templateid).then(
      templateFetchSuccess,
      templateFetchFail,
    );
  }, []);

  const updateBrandValue = (e) => {
    let selectedBrandName = e.currentTarget.value;
    //setSelectedBrandValue(selectedBrandName);
    let updatedTemplateInfo = { ...templateInfo, brand: selectedBrandName };
    // console.log(updatedTemplateInfo);
    setTemplateInfo(updatedTemplateInfo);
  };

  return (
    <>
      {canRender && (
        <form className="indi-add-template-form">
          <div>
            <div className="indi-body-title">Add template</div>
            {showAlert && (
              <Alert className="indi-status-message in" variant="danger">
                {formValidateErrorMessage}
              </Alert>
            )}
            <div className="indi-data-table-wrapper d-flex indi-text-btn-row">
              <FloatingLabel label="Template name">
                <Form.Control
                  type="text"
                  className="indi-input-field"
                  id="name"
                  placeholder="Enter template name"
                  autoComplete="off"
                  onChange={templateNameHandler}
                  defaultValue={templateInfo.templateName}
                />
              </FloatingLabel>
              <div className="indi-right-button-wrapper">
                <Button onClick={onSaveTemplate}>Update</Button>
                <Button onClick={navigateToTemplatesListPage}>Cancel</Button>
              </div>
            </div>

            <div className="indi-data-table-wrapper d-flex indi-text-btn-row">
              <FloatingLabel label="Select brand">
                <Form.Select
                  id="brand"
                  size="sm"
                  className="indi-input-field indi-input-select-field"
                  onChange={updateBrandValue}
                  defaultValue={templateInfo.brand}
                >
                  {brands?.map((brand, index) => (
                    <option value={brand.name} key={index}>
                      {brand.name}
                    </option>
                  ))}
                </Form.Select>
              </FloatingLabel>
            </div>

            <div className="indi-data-table-wrapper d-flex indi-text-btn-row">
              <FloatingLabel label="Template logo BG Color">
                <Form.Control
                  type="text"
                  className="indi-input-field"
                  id="logoColor"
                  placeholder="Enter template name"
                  autoComplete="off"
                  onChange={templateLogoBGColorHandler}
                  defaultValue={logoBGColor}
                />
              </FloatingLabel>
              <Form.Control
                type="color"
                className="indi-input-field indi-color-input-field"
                id="logoColor1"
                placeholder=""
                autoComplete="off"
                onChange={templateLogoBGInputColorHandler}
                defaultValue={logoBGColor}
              />
            </div>

            <div className="indi-data-table-wrapper d-flex indi-text-btn-row">
              <FloatingLabel label="Joint Logo BG Color">
                <Form.Control
                  type="text"
                  className="indi-input-field"
                  id="jointLogoColor"
                  placeholder="Enter template name"
                  autoComplete="off"
                  onChange={templateJointLogoBGColorHandler}
                  defaultValue={jointLogoBGColor}
                />
              </FloatingLabel>
              <Form.Control
                type="color"
                className="indi-input-field indi-color-input-field"
                id="jointLogoColor1"
                placeholder=""
                autoComplete="off"
                onChange={templateJointLogoBGInputColorHandler}
                defaultValue={jointLogoBGColor}
              />
            </div>

            <div className="indi-data-table-wrapper d-flex indi-text-btn-row">
              <Form.Check
                type="switch"
                className="indi-input-switch-field"
                id="includeAddress"
                defaultChecked={templateInfo.includeAddress}
                label="Include address?"
                onChange={templateIncludeAddressHandler}
              />
            </div>
          </div>
          <Accordion className="indi-data-table-wrapper" defaultActiveKey="0">
            <Accordion.Item eventKey="0">
              <Accordion.Header>Image uploads</Accordion.Header>
              <Accordion.Body>
                <Table responsive="sm">
                  <thead className="indi-data-table-header">
                    <tr>
                      <th>Image place</th>
                      <th className="text-center">Upload</th>
                      <th className="text-center">Preview</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr className="indi-data-table-tr">
                      <td className="indi-data-table-td-badge-first-name">
                        Template background image
                      </td>

                      <td className="indi-data-table-td-template-image text-center">
                        <div className="indi-add-form-item-input indi-upload-picture-file-input-wrapper">
                          <input
                            type="file"
                            id="iconImage"
                            imgindex={0}
                            imgname="backgroundImage"
                            className="indi-upload-picture-file-input"
                            onChange={onChangeImage}
                          />
                          <div className="indi-add-img-wrapper"></div>
                        </div>
                      </td>

                      <td className="indi-data-table-td-template-img-prevew text-center">
                        <div className="indi-add-img-wrapper-backgroundImage d-none">
                          no preview
                        </div>
                        <img
                          src={templateInfo.backgroundImage}
                          alt="background"
                          className="indi-add-img-wrapper-preview indi-add-img-wrapper-preview-backgroundImage"
                        />
                      </td>
                    </tr>

                    <tr className="indi-data-table-tr">
                      <td className="indi-data-table-td-badge-last-name">
                        Template logo image
                      </td>

                      <td className="indi-data-table-td-template-image text-center">
                        <div className="indi-add-form-item-input indi-upload-picture-file-input-wrapper">
                          <input
                            type="file"
                            imgindex={1}
                            imgname="logoImage"
                            id="iconImage"
                            className="indi-upload-picture-file-input"
                            onChange={onChangeImage}
                          />
                          <div className="indi-add-img-wrapper"></div>
                        </div>
                      </td>

                      <td className="indi-data-table-td-template-img-prevew text-center">
                        <div className="indi-add-img-wrapper-logoImage d-none">
                          no preview
                        </div>
                        <img
                          src={templateInfo.logoImage}
                          alt="background"
                          className="indi-add-img-wrapper-preview indi-add-img-wrapper-preview-logoImage"
                        />
                      </td>
                    </tr>

                    <tr className="indi-data-table-tr">
                      <td className="indi-data-table-td-user-email">
                        Template profile picture
                      </td>

                      <td className="indi-data-table-td-template-image text-center">
                        <div className="indi-add-form-item-input indi-upload-picture-file-input-wrapper">
                          <input
                            type="file"
                            imgindex={2}
                            imgname="profilePicture"
                            id="iconImage"
                            className="indi-upload-picture-file-input"
                            onChange={onChangeImage}
                          />
                          <div className="indi-add-img-wrapper"></div>
                        </div>
                      </td>

                      <td className="indi-data-table-td-template-img-prevew text-center">
                        <div className="indi-add-img-wrapper-profilePicture d-none">
                          no preview
                        </div>
                        <img
                          src={templateInfo.profilePicture}
                          alt="background"
                          className="indi-add-img-wrapper-preview indi-add-img-wrapper-preview-profilePicture"
                        />
                      </td>
                    </tr>

                    <tr className="indi-data-table-tr">
                      <td className="indi-data-table-td-user-email">
                        Template joint logo image
                      </td>

                      <td className="indi-data-table-td-template-image text-center">
                        <div className="indi-add-form-item-input indi-upload-picture-file-input-wrapper">
                          <input
                            type="file"
                            imgindex={3}
                            imgname="jointLogoImage"
                            id="iconImage"
                            className="indi-upload-picture-file-input"
                            onChange={onChangeImage}
                          />
                          <div className="indi-add-img-wrapper"></div>
                        </div>
                      </td>

                      <td className="indi-data-table-td-template-img-prevew text-center">
                        <div className="indi-add-img-wrapper-jointLogoImage d-none">
                          no preview
                        </div>
                        <img
                          src={templateInfo.jointLogoImage}
                          alt="background"
                          className="indi-add-img-wrapper-preview indi-add-img-wrapper-preview-jointLogoImage"
                        />
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="1">
              <Accordion.Header>Badges selection</Accordion.Header>
              <Accordion.Body>
                <Table responsive="sm">
                  <thead className="indi-data-table-header">
                    <tr>
                      <th>Select </th>
                      <th>Badge name </th>
                      <th>Badge icon </th>
                      <th>Constant </th>
                      <th>isDefault? </th>
                      <th>Multiple </th>
                      {/* <th>Required </th> */}
                      <th>Default value </th>
                    </tr>
                  </thead>
                  <tbody>
                    {badges?.map((badge, index) => {
                      // changes are made to ensure the CSS class name is encoded to base64 
                      // and then replace special characters in it so that class name problem won't arise in case of special characters
                      const encodedBadgeUID = customEncode(badge);
                      return (
                        <tr key={index} className="indi-data-table-tr">
                          <td className="indi-data-table-td-badge-id">
                            <Form.Check
                              type="checkbox"
                              className={`indi-template-badge-select-${encodedBadgeUID}`}
                              badgeuid={badge?.badgeUID}
                              onChange={updateSelectedBadgeInfo}
                              id={badge?.id}
                              defaultChecked={badge?.templateBadgeId ?? false}
                            />
                          </td>

                          <td className="indi-data-table-td-badge-name">
                            {badge?.name}
                          </td>

                          <td className="indi-data-table-td-badge-logo text-center">
                            <img
                              src={badge.iconImage}
                              className="indi-add-template-badge-icon-image"
                              alt="icon"
                            />
                          </td>

                          <td className="indi-data-table-td-badge-constant text-center">
                            <Form.Check
                              type="checkbox"
                              className={`indi-template-badge-constant-${encodedBadgeUID}`}
                              id={`badge-constant-${badge?.id}`}
                              defaultChecked={badge?.constant}
                            />
                          </td>

                          <td className="indi-data-table-td-badge-isdefault text-center">
                            <Form.Check
                              type="checkbox"
                              className={`indi-template-badge-isdefault-${encodedBadgeUID}`}
                              id={`badge-isdefault-${badge?.id}`}
                              defaultChecked={badge?.default}
                            />
                          </td>

                          <td className="indi-data-table-td-badge-multiple text-center">
                            <Form.Check
                              type="checkbox"
                              className={`indi-template-badge-multiple-${encodedBadgeUID}`}
                              id={`badge-multiple-${badge?.id}`}
                              defaultChecked={badge?.multiple}
                            />
                          </td>

                          {/* <td className="indi-data-table-td-badge-required text-center">
                            <Form.Check
                              type="checkbox"
                              id={`badge-required-${badge?.id}`}
                            />
                          </td> */}

                          <td className="indi-data-table-td-badge-defaultvalue">
                            <Form.Control
                              type="text"
                              className={`indi-template-badge-defaultvalue-${encodedBadgeUID}`}
                              id={`badge-defaultvalue-${badge?.id}`}
                              defaultValue={badge?.defaultValue}
                            />
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </form>
      )}
    </>
  );
};

export default EditTemplate;
